import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';

import './DropdownSearch.scss';

import { InputWithIcon } from '..';

export default class DropdownSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showDropdown': props.showDropDown ? true : false,
    };
    this.dropdown = createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutSide);

    if (this.props.showDropDown) {
      document.getElementById(this.props.id).focus();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutSide);
  }

  handleClickOutSide = event => {
    if (this.dropdown.current && !this.dropdown.current.contains(event.target)) {
      if (this.props.handleClickOutSide && this.state.showDropdown) {
        this.props.handleClickOutSide();
        return this.setState({ 'showDropdown': false });
      }
      return this.setState({ 'showDropdown': false });
    }
    return;
  }

  handleChange = (event) => {
    this.setState({ 'showDropdown': true });
    return this.props.onChange(event);
  }

  handleShowItem = () => this.setState({ 'showDropdown': !this.state.showDropdown });

  render() {
    const { template, value, icon, placeholder, onKeyPress, handleClearValue, disabled, items, id, noIcon, alignIconRight, error } = this.props;
    const { showDropdown } = this.state;

    return (
      <div className="DropdownSearch" ref={this.dropdown}>
        {
          noIcon ?
            <Input
              className={`template-${template}${error ? ' error' : ''}`}
              id={id}
              value={value ? value.label ? value.label : value : ''}
              icon={icon}
              placeholder={placeholder}
              onKeyPress={onKeyPress}
              type={value ? 'clear' : 'text'}
              disabled={disabled}
              onChange={disabled ? () => null : this.handleChange}
            />
            : <InputWithIcon
              id={id}
              template={template}
              value={value ? value.label ? value.label : value : ''}
              icon={icon}
              placeholder={placeholder}
              onKeyPress={onKeyPress}
              type={value ? 'clear' : 'text'}
              handleClearValue={handleClearValue}
              onClick={this.handleShowItem}
              disabled={disabled}
              onChange={disabled ? () => null : this.handleChange}
              alignIconRight={alignIconRight}
              error={error}
            />
        }
        <div className="box">
          <div className={`box-items template-${template} ${showDropdown && items && items.length > 0 && value ? ' active' : ''}`}>
            {items}
          </div>
        </div>
      </div>
    );
  }
}

DropdownSearch.propTypes = {
  'template': PropTypes.string,
  'value': PropTypes.any,
  'icon': PropTypes.string,
  'placeholder': PropTypes.string,
  'onKeyPress': PropTypes.func,
  'handleClearValue': PropTypes.func,
  'items': PropTypes.array,
  'disabled': PropTypes.bool,
  'onChange': PropTypes.func.isRequired,
  'id': PropTypes.string,
  'noIcon': PropTypes.bool,
  'handleClickOutSide': PropTypes.func,
  'alignIconRight': PropTypes.bool,
  'showDropDown': PropTypes.bool,
  'error': PropTypes.bool,
};
